import styled from "@emotion/styled";

export const ReviewTrucksContentWrapper = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	padding: 20,
	gap: "24px",
	".MuiAlert-message": {
		"p:last-of-type": {
			margin: 0
		},
		ul: {
			marginTop: 0
		}
	}
}));

export const TruckSubheaderWrapper = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	h5: {
		margin: 0,
		color: theme.project.colors.primaryColors.main
	}
}));
